const Backbone = require('backbone');
const FinishView = require('views/store/pages/products/finish');

var FinishesView = Backbone.View.extend({
	el: '.js-finishes',
	initialize: function(options) {
		this.options = Object.assign({}, options);
		var viewOptions = {
			parentView: this
		};

		this.childViews.finishes = [];

		this.collection.each(
			function(model) {
				this.childViews.finishes.push(
					new FinishView({
						el: this.$(`.js-finish-${model.get('uniqueId')}`).closest('li'),
						model: model,
						options: viewOptions,
						pageView: this.options.pageView
					})
				);
			}.bind(this)
		);
	},
	getChosenFinishModel: function() {
		return this.collection.findWhere({ selectedFinish: true });
	}
});
module.exports = FinishesView;
